import { toStringBool } from '../configs/booleans';
import useSearchQueryParam from './useSearchQueryParam';

function useSearchQueryBoolParam(param: string, filter: boolean | null) {
  useSearchQueryParam(param, filter === null ? '' : toStringBool(filter));
}

export default useSearchQueryBoolParam;
